import { createFileRoute } from '@tanstack/react-router'

import { firstOfMonth, lastOfMonth, monthOf, today } from '../lib/format'
import { dayQuery, historyQuery } from '../lib/queries'
import { Spf } from '../screens/Spf'

type SpfSearch = { month?: string; day?: string }

export const Route = createFileRoute('/spf')({
  validateSearch: (search: Record<string, unknown>): SpfSearch => ({
    month: typeof search.month === 'string' ? search.month : undefined,
    day: typeof search.day === 'string' ? search.day : undefined,
  }),
  loaderDeps: ({ search }) => ({ month: search.month ?? monthOf(today()) }),
  loader: ({ context, deps }) =>
    Promise.all([
      context.queryClient.ensureQueryData(dayQuery('today')),
      context.queryClient.ensureQueryData(
        historyQuery(firstOfMonth(deps.month), lastOfMonth(deps.month)),
      ),
    ]),
  component: Spf,
})
